<div class="dialog-container">
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">{{ dialogTitle }}</h4>
        <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSave()">

        <!-- Category: categoryId + description -->
        <ng-container *ngIf="mode === 'add-category' || mode === 'edit-category'">
            <div class="form-group mb-3">
                <label for="categoryId" class="form-label">Category ID <span class="req">*</span></label>
                <input id="categoryId" type="text" class="form-control" formControlName="categoryId"
                       placeholder="Category ID" [class.is-invalid]="isFieldInvalid('categoryId')">
                <div *ngIf="isFieldInvalid('categoryId')" class="invalid-feedback">Category ID is required</div>
            </div>
            <div class="form-group mb-3">
                <label for="catDesc" class="form-label">Description</label>
                <input id="catDesc" type="text" class="form-control" formControlName="description" placeholder="Description">
            </div>
        </ng-container>

        <!-- SubCategory: subCategoryId + categoryId (readonly) + description -->
        <ng-container *ngIf="mode === 'add-subcategory' || mode === 'edit-subcategory'">
            <div class="form-group mb-3">
                <label for="subCategoryId" class="form-label">Sub Category ID <span class="req">*</span></label>
                <input id="subCategoryId" type="text" class="form-control" formControlName="subCategoryId"
                       placeholder="Sub Category ID" [class.is-invalid]="isFieldInvalid('subCategoryId')">
                <div *ngIf="isFieldInvalid('subCategoryId')" class="invalid-feedback">Sub Category ID is required</div>
            </div>
            <div class="form-group mb-3">
                <label for="parentCategoryId" class="form-label">Category ID</label>
                <input id="parentCategoryId" type="text" class="form-control readonly-field" formControlName="categoryId" readonly>
            </div>
            <div class="form-group mb-3">
                <label for="subDesc" class="form-label">Description</label>
                <input id="subDesc" type="text" class="form-control" formControlName="description" placeholder="Description">
            </div>
        </ng-container>

        <!-- SubSubCategory: subSubCategoryId + subCategoryId (readonly) + description -->
        <ng-container *ngIf="mode === 'add-subsubcategory' || mode === 'edit-subsubcategory'">
            <div class="form-group mb-3">
                <label for="subSubCategoryId" class="form-label">Sub Sub Category ID <span class="req">*</span></label>
                <input id="subSubCategoryId" type="text" class="form-control" formControlName="subSubCategoryId"
                       placeholder="Sub Sub Category ID" [class.is-invalid]="isFieldInvalid('subSubCategoryId')">
                <div *ngIf="isFieldInvalid('subSubCategoryId')" class="invalid-feedback">Sub Sub Category ID is required</div>
            </div>
            <div class="form-group mb-3">
                <label for="parentSubCategoryId" class="form-label">Sub Category ID</label>
                <input id="parentSubCategoryId" type="text" class="form-control readonly-field" formControlName="subCategoryId" readonly>
            </div>
            <div class="form-group mb-3">
                <label for="ssDesc" class="form-label">Description</label>
                <input id="ssDesc" type="text" class="form-control" formControlName="description" placeholder="Description">
            </div>
        </ng-container>

        <div class="dialog-footer d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn cancel-btn" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn save-btn">Save</button>
        </div>
    </form>
</div>
